import { render, staticRenderFns } from "./AboutUsListing.vue?vue&type=template&id=b59ff2be&"
import script from "./AboutUsListing.vue?vue&type=script&lang=js&"
export * from "./AboutUsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports